export const youtubeUrl = (url: string) => {
  const match = url.match(
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  )
  return match && match[7].length === 11 ? match[7] : false
}

export const jsonCopy = <T>(data: T): T => JSON.parse(JSON.stringify(data))

export const encodeSweUrlComponent = (s: string) =>
  s
    ? encodeURIComponent(
        s
          .toLowerCase()
          .split(' ')
          .join('-')
          .split('_')
          .join('-')
          .split('å')
          .join('a')
          .split('ä')
          .join('a')
          .split('ö')
          .join('o')
      )
    : ''

export const PLACEHOLDER_IMAGE = '/images/image-placeholder.png'

export const pWaitFor = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
